import { DoneOutline, Info } from "@mui/icons-material";
import { Divider } from "@mui/material";
import React from "react";
import * as msg from "utils/constants/messages";

const NoChangesWarning = (props) => {
    return <>
        <div className="block-save">
            <Info style={{ color: "var(--hti-magenta)" }} />
            <div>You haven't made any changes yet. Please make changes before submitting.</div>
        </div>
        <Divider />

        <div
            className="icon-text"
            style={{ justifyContent: "center", marginTop: "10px" }}
        >
            <button
                className="apply-button"
                style={{ width: "max-content", marginRight: "0px" }}
                onClick={props.handleSubmit}
            >
                <p className="apply-button-text">Ok</p>
            </button>
        </div>
    </>
}

export default NoChangesWarning;